import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Button, Form, Spin, message, Tabs, Col, Input } from "antd";
import { ArrowLeftOutlined, SaveOutlined } from "@ant-design/icons";
import axios from "../utils/axios";
import BreadCrumb from "../components/Breadcrumb";

function SettingAddEdit() {
  const navigate = useNavigate();
  const { editSettingId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  const get = () => {
    if (!editSettingId) return;

    setIsLoading(true);
    axios
      .get(`/settings`, { params: { _id: editSettingId } })
      .then((result) => {
        if (Array.isArray(result.data.data) && result.data.data.length) {
          const [data] = result.data.data;
          form.setFieldsValue(data);
        }
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  const onSave = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);
        if (editSettingId) values._id = editSettingId;

        axios({
          method: editSettingId ? "put" : "post",
          url: "/settings",
          data: values,
        })
          .then((result) => {
            if (result.data.success) {
              message.success(result.data.message);
              navigate("/settings");
            } else {
              message.error(result.data.message);
              setIsLoading(false);
            }
          })
          .catch(() => {
            message.error("Oops! Something went wrong!");
            setIsLoading(false);
          });
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    get();
  }, []);

  return (
    <>
      <BreadCrumb
        breadcrumbs={[
          { link: "/", label: "Home" },
          { label: "Settings" },
        ]}
      />
      <Spin spinning={isLoading}>
        <div className="main-content">
          <div className="page-header">
            <div className="page-title">
              {editSettingId ? "Edit Settings" : "Add Settings"}
            </div>
            <div className="page-title-more">
              <Link to="/settings">
                <Button icon={<ArrowLeftOutlined />}>Back</Button>
              </Link>
              <Button
                icon={<SaveOutlined />}
                type="primary"
                onClick={onSave}
                loading={isLoading}
              >
                Save
              </Button>
            </div>
          </div>

          <div className="form-content">
            <Form form={form} layout="vertical" autoComplete="off">
              <Tabs
                defaultActiveKey="1"
                items={[
                  {
                    key: "General",
                    label: "Settings Details",
                    children: (
                      <>
                        <Col sm={24} md={24}>
                          <Form.Item
                            label="WhatsApp Web Number"
                            name="whatsappNumber"
                            rules={[
                              {
                                required: true,
                                message: "WhatsApp number is required",
                              },
                            ]}
                          >
                            <Input placeholder="Enter WhatsApp number" />
                          </Form.Item>
                        </Col>

                        <Col sm={24} md={24}>
                          <Form.Item
                            label="Project Meta Data"
                            name="projectMeta"
                            rules={[
                              {
                                required: false,
                                message: "Project meta data is required",
                              },
                            ]}
                          >
                            <Input.TextArea
                              rows={8}
                              placeholder="Enter project meta data (JSON or text)"
                            />
                          </Form.Item>
                        </Col>
                      </>
                    ),
                  },
                ]}
              />
            </Form>
          </div>
        </div>
      </Spin>
    </>
  );
}

export default SettingAddEdit;
